export const PipModeReleasedDate = new Date('2025-05-22T00:00:00Z');
